import {
  ArchetypeDiscovery,
  TraitAssessmentResult,
} from "@dimensional-engineering/dimensional-models";

export function generateTraitAssessmentOutroSteps(
  type: "element" | "pattern",
  isUserPremium: boolean,
  isTraitPremium: boolean,
  archetypeDiscoveries: ArchetypeDiscovery[] | null
) {
  const steps: string[] = [
    "scaleReveal",
    "scoreDefinition",
    "scoreReveal",
    "scoreChange",
  ];

  const premiumGated = isTraitPremium === true && !isUserPremium;

  const discArchetype = archetypeDiscoveries?.find(
    (a) => a.archetype.archetypeGroupSlug === "work"
  );
  const identityArchetype = archetypeDiscoveries?.find(
    (a) => a.archetype.archetypeGroupSlug === "identity"
  );

  if (!premiumGated) {
    if (type === "pattern") {
      steps.push("components");
      steps.push("componentsChange");
    }
    if (discArchetype !== undefined || identityArchetype !== undefined) {
      steps.push("context");
    }
    steps.push("positiveAdaptations");
    steps.push("negativeAdaptations");
    steps.push("origins");
    steps.push("takeaway");
  } else {
    if (type === "pattern") {
      steps.push("components");
      steps.push("componentsChange");
    }
  }

  const outroRecord: Record<number, string> = {};

  steps.forEach((value, index) => {
    outroRecord[index] = value;
  });

  return outroRecord;
}
